/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
document.addEventListener('DOMContentLoaded', function () {

  const stickyEl = document.querySelector('sticky-scroll');
  if (!stickyEl) return;

  const scrollBox = stickyEl.querySelector('.product-single__box');
  if (!scrollBox) return;

  let lastScrollTop = 0;

  scrollBox.addEventListener('scroll', function () {

    console.log("scroll");
    const currentScrollTop = scrollBox.scrollTop;
    const maxScroll = scrollBox.scrollHeight - scrollBox.clientHeight;

    // If user scrolls down and hits bottom
    if (currentScrollTop >= maxScroll) {
      const delta = currentScrollTop - lastScrollTop;
      if (delta > 0) {
        window.scrollBy({ top: delta });
      }
    }

    // If user scrolls up and hits top
    if (currentScrollTop <= 0) {
      const delta = currentScrollTop - lastScrollTop;
      if (delta < 0) {
        window.scrollBy({ top: delta });
      }
    }

    lastScrollTop = currentScrollTop;

  });

});



